
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/case-studies",
      function () {
        return require("private-next-pages/preview/case-studies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/case-studies"])
      });
    }
  